import React from 'react';

import {Preloader} from "react-materialize";

export default class MiniLoader extends React.Component {
    render() {
        return (
            <Preloader size='small' className={this.props.className} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/MiniLoader.js